<template>
  <div class="plan-detail" v-pageBuried data-page-buried="BG_WFFJZFA">
    <img
      class="en-logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9bd932ce629eec7250a2c1b5691a1031.png"
      alt=""
    />
    <AppNavbar v-if="isApp" :options="options" :zIndex="999">
      <template slot="right">
        <div class="share iconfont icon-share" @click="bindShare"></div>
      </template>
    </AppNavbar>
    <div class="plan-container">
      <div v-if="planData">
        <div class="plan-padding">
          <PlanItem1 style="margin-bottom: 24px" :data="planData" />
          <PlanItem2 style="margin-bottom: 34px" :data="planData" />
          <PlanItem3 style="margin-bottom: 20px" :data="planData" />
          <PlanItem4 style="margin-bottom: 22px" :data="planData" />
        </div>
        <PlanItem5 style="margin-bottom: 40px" :data="planData" />
        <div class="logo-container">
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
            alt=""
          />
          <div>真人营养师健康指导平台</div>
        </div>
        <div class="consult-btn" v-show="showFixedBtn" @click="bindConsult"
          >我想深入了解</div
        >
      </div>
    </div>
    <AppLoading class="app-loading" v-if="!loaded" />
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import AppLoading from '@/components/app/loading/loading.vue'
import ShareComponent from '@/components/app/share/share.vue'
import { eventObj } from '@/components/app/share/share-method.js'
import PlanItem1 from './components/plan-item-1.vue'
import PlanItem2 from './components/plan-item-2.vue'
import PlanItem3 from './components/plan-item-3.vue'
import PlanItem4 from './components/plan-item-4.vue'
import PlanItem5 from './components/plan-item-5.vue'
export default {
  name: 'app-camp-plan-detail',
  components: {
    AppNavbar,
    AppLoading,
    ShareComponent,
    PlanItem1,
    PlanItem2,
    PlanItem3,
    PlanItem4,
    PlanItem5
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(255,255,255,0)',
        color: '#fff'
      },
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 3,
          copy: true,
          className: 'share-copy-btn'
        }
      ],
      showShare: false,
      shareOptions: {
        desc: '本方案基于国家卫生健康委《中国超重医学营养治疗指南（最新版）》文献证据，以CRD+HPD饮食干预模式为指导，在专家组共同讨论的基础上，通过调整饮食模式实现减重目标，同时辅助预防和改善情绪、皮肤、慢性病等亚健康问题。',
        title: '「」的专属减脂方案',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/11a63ad0470ecabbf34a531dcbc45c1d.png' // 分享的缩略图的url
      },
      qrcodeUrl: location.origin + location.pathname,
      planData: null,
      loaded: false,
      showFixedBtn: false,
      isApp: false
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    if (this.$route.query.uid) {
      this.getShareData()
    } else {
      this.getData()
    }
  },
  mounted() {
    this.addScroll()
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor = 'rgba(255,255,255,0)'
        this.options.color = 'rgba(255,255,255,1)'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
        this.options.color = 'rgba(0,0,0,0.8)'
      }
      if (scroll >= window.screen.height) {
        this.showFixedBtn = true
      } else {
        this.showFixedBtn = false
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindConsult() {
      if (this.$betterwe.isApp()) {
        let path =
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F0404d3648554ff897ad70758465dcd93.png'
        this.$betterwe.jumpRoute(path)
      } else {
        this.$router.push('/app-download')
      }
    },
    bindShare() {
      this.showShare = true
    },
    async getShareData() {
      let params = {
        unify_id: this.$route.query.uid
      }
      let res = await this.$http
        .getBaseApp('api/v1/NutritionServices/shareNoCampCompletePlan', params)
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.planData = res.data
          let uid = res.data?.brief_data.user_info.unify_id || 0
          if (uid) {
            this.qrcodeUrl = location.origin + location.pathname + '?uid=' + uid
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getData() {
      let res = await this.$http
        .getBaseApp('api/v1/NutritionServices/getNoCampCompletePlan', {})
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.planData = res.data
          let uid = res.data?.brief_data.user_info.unify_id || 0
          if (uid) {
            this.qrcodeUrl = location.origin + location.pathname + '?uid=' + uid
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      let truename = this.planData?.brief_data?.user_info?.truename || ''
      shareOptions.title = `「${truename}」的专属减脂方案`
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    bindCancel() {
      this.showShare = false
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-detail {
  position: relative;
}
.en-logo {
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translate(-50%, 0%);
  height: 13px;
}
.plan-container {
  min-height: 100vh;
  padding-bottom: 92px;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 92px;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/aa96201e353128ccf4be2c8e36ba65e5.png'),
    linear-gradient(180deg, #60e67f 0px, #21cb88 350px, #f5f5f5 678px);
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #f5f6fa;
  color: rgb(48, 48, 56);
  .plan-padding {
    padding: 0px 10px;
  }
  .logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 34px;
    font-family: MiSans, MiSans;
    font-size: 8px;
    line-height: 10px;
    letter-spacing: 3px;
    .logo {
      height: 18px;
      margin-bottom: 9px;
    }
  }
}
.app-loading {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
.consult-btn {
  position: fixed;
  left: 50%;
  bottom: 44px;
  transform: translate(-50%, 0%);
  width: 335px;
  height: 48px;
  background: linear-gradient(270deg, #373a56 0%, #565e7a 100%);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.14);
  border-radius: 24px;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  line-height: 48px;
  animation: slideIn 0.5s ease;
}
@keyframes slideIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
